import CategoryCard from '../../../components/card/categoryCard/CategoryCard';
import { CategoriesContext } from '../../../context/CategoriesContext';
import classes from './UserCategories.module.css';
import { useContext } from 'react';

const UserCategories = (props) => {
  const { editCategoryClick, onChangeaCategory, checkedData, hidden} = props;
  const { categories } = useContext(CategoriesContext);

  return (
    <div className={`d-flex justify-content-center w-100 flex-wrap`}>
      <div className={`${classes.category_item_container} d-flex justify-content-start flex-wrap`}>
        {categories.map((category) => {
          return (
            <CategoryCard
              data={category}
              onChange={onChangeaCategory}
              hidden={hidden}
              onClick={editCategoryClick}
              key={category._id}
              className={`${classes.edit_category_container} w-100`}
              categories={checkedData}
            />
          );
        })}
      </div>
    </div>
  );
};

export default UserCategories;
